import React from 'react'
import Select from 'react-select'
import { observer } from 'mobx-react'
import Grid from '@material-ui/core/Grid';
import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@mui/material/Typography';

import SendIcon from '@mui/icons-material/Send';
import DevicesIcon from '@mui/icons-material/Devices';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GroupIcon from '@mui/icons-material/Group';

import HomeIcon from '@mui/icons-material/Home';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import FastForwardIcon from '@mui/icons-material/FastForward';
import IconButton from '@mui/material/IconButton';
import LaptopIcon from '@mui/icons-material/Laptop';

import Divider from '@mui/material/Divider';


import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles((theme) => ({
  manrope: {
		fontFamily: 'Manrope',
  },
}));

const specialServicesMap = {
  'Atención a domicilio': {
  	icon: (<HomeIcon color='primary'/>),
  },
  'Atención domingos': {
  	icon: (<ScheduleIcon color='primary'/>),
  },
  'Atención feriados': {
  	icon: (<ScheduleIcon color='primary'/>),
  },
  'Atención sábados': {
  	icon: (<ScheduleIcon color='primary'/>),
  },
  'Emergencia 24 horas': {
  	icon: (<LocalHospitalIcon color='primary'/>),
  },
  'Envío de muestras al exterior': {
  	icon: (<SendIcon color='primary'/>),
  },
  'Procesamiento urgente': {
  	icon: (<PriorityHighIcon color='primary'/>),
  },
  'Servicio rápido': {
  	icon: (<FastForwardIcon color='primary'/>)
  },
  'Consulta online': {
    icon: (<LaptopIcon color='primary'/>)
  },
}

const SpecialServices = observer(({specialServices}) => {

	const classes = useStyles();

            console.log(specialServices.length)

  return(
			<Grid container>
        <Grid item>
          <Box m={1} pt={1}>
            <Typography variant="h6">
              Servicios especiales
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
            <List dense={true}>
				      { specialServices.map(function(service) {
				        return (
		                <ListItem>
		                  <ListItemIcon>
		                    {specialServicesMap[service].icon}
		                  </ListItemIcon>
		                  <ListItemText
		                    primary={service}
		                    primaryTypographyProps={{variant: 'body1'}}
		                    className={classes.manrope}
		                  />
		                </ListItem>
				        )
				      	})}
            </List>
        </Grid>
      </Grid>
  );
});

export default SpecialServices;